import React, { Component } from "react";
import { Container, Button, Table, Row, Col } from "react-bootstrap";
import AppSpinner from "../AppSpinner/AppSpinner";
import apiUrl from "../../utils/apiUrl";
import { connect } from "react-redux";
import "./styles/styles.scss";
import formatMoney from "../../utils/formatMoney";

const select = (state) => {
  return {
    token: state.auth.token,
  };
};

class ConnectedFoundationExtractComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      payments: [],
      disbursements: [],
      available: 0,
      discounted: 0,
      disbursed: 0,
      total: 0,
      isLoading: true,
      transactions: [],
      programPaymentsInfo: [],
      walletSuscriptionPaymentsInfo: {},
      disbursementItems: [],
      allTransactions: [],
      paymentsInfo: {},
      disbursementsInfo: {},
      allWalletSuscriptionPaymentsInfo: {},
      foundation: {},
    };
  }

  getTotalAvailable() {
    const { payments, foundation } = this.state;

    let totalRaised = 0;
    let impuestos = 0;
    let cuatroPorMil = 0;
    let costoTransferencia = 0;
    let costosFinancieros = 0;
    let comisionNibi = 0;
    let available = 0;

    const disbursablePayments = payments.filter((payment) => {
      return !payment.disbursementId;
    });

    if (
      foundation.bankName &&
      foundation.bankName.toLowerCase() !== "bancolombia"
    )
      costoTransferencia = 7800;

    for (let i = 0; i < disbursablePayments.length; i++) {
      totalRaised += disbursablePayments[i].amount;
      impuestos +=
        disbursablePayments[i].iva +
        disbursablePayments[i].retencionIVA +
        disbursablePayments[i].retencionICA +
        disbursablePayments[i].retencionFuente;
      costosFinancieros +=
        disbursablePayments[i].feePasarela +
        disbursablePayments[i].comisionPasarela;
      comisionNibi += disbursablePayments[i].fareNibi;
    }

    cuatroPorMil =
      (4 * (totalRaised - impuestos - costosFinancieros - comisionNibi)) / 1000;
    available =
      totalRaised -
      impuestos -
      comisionNibi -
      costosFinancieros -
      cuatroPorMil -
      costoTransferencia;

    this.setState({
      totalRaised,
      preAvailable: available + costoTransferencia,
      available,
      impuestos,
      comisionNibi,
      cuatroPorMil,
      costosFinancieros,
      costoTransferencia,
    });
  }

  async componentDidMount() {
    const { id, token } = this.props;

    const foundationResp = await fetch(
      `${apiUrl}/admin/foundation-extract/${id}?token=${token}`
    );
    const foundationData = await foundationResp.json();
    if (foundationData.success) {
      this.setState({
        payments: foundationData.payments || [],
        foundation: foundationData.foundation || {},
        transactions: foundationData.transactions || [],
        allTransactions: foundationData.allTransactions || [],
        paymentsInfo: foundationData.paymentsInfo || {},
        disbursementsInfo: foundationData.disbursementsInfo || {},
        allWalletSuscriptionPaymentsInfo:
          foundationData.allWalletSuscriptionPaymentsInfo || {},
        walletSuscriptionPaymentsInfo:
          foundationData.walletSuscriptionPaymentsInfo || {},
        disbursements: foundationData.disbursements || [],
        programPaymentsInfo: foundationData.programPaymentsInfo || [],
        isLoading: false,
      });
      this.getTotalAvailable();
    } else {
      this.setState({ isLoading: false });
    }
  }

  render() {
    const {
      isLoading,
      payments,
      transactions,
      programPaymentsInfo,
      walletSuscriptionPaymentsInfo,
      disbursementItems,
      allTransactions,
      paymentsInfo,
      disbursementsInfo,
      allWalletSuscriptionPaymentsInfo,
      foundation,
    } = this.state;
    const { history } = this.props;

    let recurringTotalAmount = 0;
    let recurringTotalDisponible = 0;
    let recurringTotalFees = 0;

    transactions.forEach((item) => {
      if (!item.programId && !item.disbursementId) {
        recurringTotalAmount += item.amount;
        recurringTotalDisponible += item.disponible;
        recurringTotalFees +=
          item.iva +
          item.retencionICA +
          item.retencionFuente +
          item.retencionIVA +
          item.feePasarela +
          item.comisionPasarela +
          item.fareNibi;
      }
    });

    const totalProgramDisponible = programPaymentsInfo.reduce(
      (prev, item) => prev + item.disponible,
      0
    );
    const totalDisponible =
      recurringTotalDisponible +
      totalProgramDisponible -
      (walletSuscriptionPaymentsInfo.amount || 0);

    let disbursementPreavailble = 0;
    let disbursementFees = 0;
    let disbursementDisponible = 0;

    disbursementItems.forEach((item) => {
      if (item.disbursementType === "ORG") {
        disbursementPreavailble += recurringTotalAmount;
        disbursementFees += recurringTotalFees;
        disbursementDisponible += recurringTotalDisponible;
      } else if (item.disbursementType === "PROGRAM") {
        disbursementPreavailble += item.amount;
        disbursementFees +=
          item.iva +
          item.fareNibi +
          item.retencionFuente +
          item.retencionIVA +
          item.retencionICA +
          item.feePasarela +
          item.comisionPasarela;
        disbursementDisponible += item.disponible;
      }
    });

    if (walletSuscriptionPaymentsInfo && walletSuscriptionPaymentsInfo.amount)
      disbursementDisponible -= walletSuscriptionPaymentsInfo.amount;

    const programList = [];

    allTransactions.forEach((item) => {
      const name =
        item.dbType === "SUBSCRIPTION_PAYMENT"
          ? "Subscripciones"
          : item.programId
          ? item.programName
          : "Organización";
      const index = programList.findIndex((it2) => it2 === name);

      if (index === -1) programList.push(name);
    });

    const totalFees =
      (paymentsInfo.fees || 0) +
      (disbursementsInfo.fees || 0) +
      (allWalletSuscriptionPaymentsInfo.amount || 0);

    if (isLoading) return <AppSpinner />;
    return (
      <div className="detail-info-component foundation-detail-component">
        <Container>
          <h1>{foundation.name}</h1>
          <Row>
            <Col>
              <h2>Total recaudado: {formatMoney(paymentsInfo.amount || 0)}</h2>
            </Col>
            <Col>
              <h2>Total descontado: {formatMoney(totalFees)}</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <h2>
                Total desembolsado: {formatMoney(disbursementsInfo.amount)}
              </h2>
            </Col>
            <Col>
              <h2>
                Total disponible:{" "}
                {formatMoney(totalDisponible >= 0 ? totalDisponible : 0)}
              </h2>
            </Col>
          </Row>

          <h1>Movimientos</h1>
          <Table striped bordered hover size="sm" className="paymentTable">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Donante</th>
                <th>Monto</th>
                <th>Tipo de donación</th>
                <th>Desembolso</th>
                <th>Fecha de solicitud de desembolso</th>
                <th>Fecha de pago de desembolso</th>
                <th>Cantidad del desembolso</th>
                <th>Método de pago</th>
                <th>Comisión Nibi</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, _id) => (
                <tr key={_id}>
                  <td>{new Date(payment.datePayed).toLocaleString()}</td>
                  <td>
                    <Button
                      variant="info"
                      size="sm"
                      onClick={() => {
                        history.push(`/usuarios/${payment.userId}`);
                      }}
                    >
                      Ver Usuario
                    </Button>
                  </td>
                  <td>{formatMoney(payment.amount)}</td>
                  <td>{payment.type}</td>
                  <td>{payment.disbursed}</td>
                  <td>
                    {payment.disbursementReqDate
                      ? new Date(payment.disbursementReqDate).toLocaleString()
                      : "-"}
                  </td>
                  <td>
                    {payment.disbursementRecDate
                      ? new Date(payment.disbursementRecDate).toLocaleString()
                      : "-"}
                  </td>
                  <td>
                    {payment.disbursementAmount
                      ? formatMoney(payment.disbursementAmount)
                      : "-"}
                  </td>
                  <td>{payment.paymentMethod}</td>
                  <td>{formatMoney(payment.fareNibi)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Container>
      </div>
    );
  }
}

const FoundationDetailComponent = connect(select)(
  ConnectedFoundationExtractComponent
);

export default FoundationDetailComponent;
